import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import styles from './RemoteOralExam.scss';
import { t } from '../../services/i18nService';
import JoinController from './JoinController';
import remoteOralExamService from '../../services/RemoteOralExamService';

const WaitingRoom = ({ isCandidateJoined, isInProgress, allShownChecksCompleted, status = {} }) => {
    const fallbackMessage = t('remoteOralExam.waitingRoom.examinerWillBeShortly');
    const statusMessage = status.statusMessage || fallbackMessage;

    useEffect(() => {
        if (allShownChecksCompleted) {
            remoteOralExamService.scheduleFetchingOfSessionInfo();
        }
    }, [allShownChecksCompleted]);

    const getWaitingRoomContent = () => {
        if (isCandidateJoined) {
            return (<div className={styles.description}>
                <p>
                    <span className={styles.iconIndent}>
                        {statusMessage}
                    </span>
                </p>
            </div>);
        }

        return <JoinController isInProgress={isInProgress} />;
    };

    return (<div className={styles.wrapper}>
        <h3>{t('remoteOralExam.waitingRoom.label')}</h3>
        { allShownChecksCompleted && getWaitingRoomContent()}
    </div>
    );
};

WaitingRoom.propTypes = {
    allShownChecksCompleted: PropTypes.bool.isRequired,
    isCandidateJoined: PropTypes.bool.isRequired,
    isInProgress: PropTypes.bool.isRequired,
    status: PropTypes.object,
};

export default WaitingRoom;
